export type SearchCriteria = [{
  operator: SearchOperator,
  value: any[]
}]

export enum SearchOperator {
  EQUAL = '=',
  NOT_EQUAL = '!=',

  LIKE = '~~*',
  NOT_LIKE = '!~~*',
  LESS = 'lt',
  LESS_OR_EMPTY = 'lt0',
  LESS_OR_EQUAL = 'lte',
  LESS_OR_EQUAL_OR_EMPTY = 'lte0',
  GREATER = 'gt',
  GREATER_OR_EMPTY = 'gt0',
  GREATER_OR_EQUAL = 'gte',
  GREATER_OR_EQUAL_OR_EMPTY = 'gte0',
  BETWEEN = 'BETWEEN',

  // Array
  CONTAINS_ANY = '&&',
  NOT_CONTAINS_ANY = '!&&',
  CONTAINS_ALL = '@>',

  NO_VALUE = '0',
  HAS_VALUE = '1',
  HIERARCHICAL_ANY = 'h1',
  HIERARCHICAL_ALL = 'h2'
}
